
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homewarranty.center/privacy-policy",
      function () {
        return require("private-next-pages/homewarranty.center/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homewarranty.center/privacy-policy"])
      });
    }
  